<template>
  <div class="exchangeMembershipAppsDashboard js-tabBox exchangeMembershipAppsDashboard--admin">
    <div class="exchangeMembershipAppsDashboard__header">
      <div class="exchangeMembershipAppsDashboard__title">Exchange Membership Apps</div>
      <div class="exchangeMembershipAppsDashboard__nav">
        <div class="exchangeMembershipAppsDashboard__nav-container">
          <div data-id="in-progress" class="exchangeMembershipAppsDashboard__nav-item js-tabNavItem" @click="tabActivate">
            <span class="text">In Progress</span>
          </div>
          <div class="exchangeMembershipAppsDashboard__nav-item js-tabNavItem" @click="tabActivate">
            <span class="text">Drafts</span>
          </div>
          <div data-id="confirmed" class="exchangeMembershipAppsDashboard__nav-item js-tabNavItem" @click="tabActivate">
            <span class="text">Confirmed</span>
          </div>
          <div data-id="declined" class="exchangeMembershipAppsDashboard__nav-item js-tabNavItem" @click="tabActivate">
            <span class="text">Declined</span>
          </div>
        </div>
        <div class="exchangeMembershipAppsDashboard__nav-container">
          <div class="exchangeMembershipAppsDashboard__nav-item" @click="exportToExcel()">
            <span class="text">Export</span>
          </div>
        </div>
      </div>
    </div>
    <div class="exchangeMembershipAppsDashboard__content">
      <div class="exchangeMembershipAppsDashboard__content-item js-tabContentItem">
        <div class="exchangeMembershipAppsDashboard__table">
            <Pagination
            :pageCount="inProgressListPageCount"
            :rowCount="inProgressListCount"
            @pageClick="onInProgressPageClick"
            />
          <div class="exchangeMembershipAppsDashboard__table-header">
            <div class="exchangeMembershipAppsDashboard__table-cell">№</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Name</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Period</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Status</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Created On</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Payment method</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Potential account</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Referral code</div>
          </div>
          <div class="exchangeMembershipAppsDashboard__table-body js-customScroll">
            <vue-scroll :ops="ops">
              <div
                v-for="(item, index) of inProgressList"
                :key="index"
                class="exchangeMembershipAppsDashboard__table-row js-acc-item js-acc-hover-item"
                @mouseenter="controlShow"
                @mouseleave="controlHide"
              >
                <div class="exchangeMembershipAppsDashboard__table-row-header js-acc-title">
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <div class="exchangeMembershipAppsDashboard__table-index">{{inProgressList.length - index}}</div>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <a
                    @click="openAdditionalDetails(item)"
                    class="exchangeMembershipAppsDashboard__table-name">{{item.firstName + ' ' + item.lastName}}</a>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <div class="exchangeMembershipAppsDashboard__table-phone">{{item.periodName}}</div>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">{{getPaymentInfo(item)}}</div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <span>{{getDisplayDateTime(item.createdOn)}}</span>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <div class="exchangeMembershipAppsDashboard__table-phone">{{item.paymentMethodLinked ? 'Linked' : ''}}</div>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <a
                    v-if="item.possibleFlyer != null"
                    @click="openAdditionalDetails(item.possibleFlyer)"
                    class="exchangeMembershipAppsDashboard__table-name">{{item.possibleFlyer.firstName + ' ' + item.possibleFlyer.lastName}}</a>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">{{item.promo ? item.promo.code : ''}}</div>
                </div>
                <div class="exchangeMembershipAppsDashboard__table-row-control js-acc-hover-content">
                  <div class="exchangeMembershipAppsDashboard__table-row-control-inner ">
                    <p class="exchangeMembershipAppsDashboard__table-link" @click="() => acceptApplicationClick(item)">
                      <span class="icon" />
                      <span class="text">Accept</span>
                    </p>
                    <p class="exchangeMembershipAppsDashboard__table-link" @click="() => declineApplicationClick(item)">
                      <span class="icon" />
                      <span class="text">Decline</span>
                    </p>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <div class="exchangeMembershipAppsDashboard__content-item js-tabContentItem">
          <div class="exchangeMembershipAppsDashboard__table">
            <Pagination
            :pageCount="draftsListPageCount"
            :rowCount="draftsListCount"
            @pageClick="onDraftsPageClick"
          />
          <div class="exchangeMembershipAppsDashboard__table-header">
            <div class="exchangeMembershipAppsDashboard__table-cell">№</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Name</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Created On</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Referral code</div>
          </div>
          <div class="exchangeMembershipAppsDashboard__table-body js-customScroll">
            <vue-scroll :ops="ops">
              <div
                v-for="(item, index) of draftsList"
                :key="index"
                class="exchangeMembershipAppsDashboard__table-row js-acc-item"
              >
                <div class="exchangeMembershipAppsDashboard__table-row-header js-acc-title">
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <div class="exchangeMembershipAppsDashboard__table-index">{{draftsList.length - index}}</div>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <a
                    @click="openAdditionalDetails(item)"
                    class="exchangeMembershipAppsDashboard__table-name">{{item.firstName + ' ' + item.lastName}}</a>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <span>{{getDisplayDateTime(item.createdOn)}}</span>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">{{item.promo ? item.promo.code : ''}}</div>
                </div>
                <div class="exchangeMembershipAppsDashboard__table-row-control js-acc-hover-content">
              </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <div class="exchangeMembershipAppsDashboard__content-item js-tabContentItem">
        <div class="exchangeMembershipAppsDashboard__table">
            <Pagination
            :pageCount="confirmedListPageCount"
            :rowCount="confirmedListCount"
            @pageClick="onConfirmedPageClick"
            />
          <div class="exchangeMembershipAppsDashboard__table-header">
            <div class="exchangeMembershipAppsDashboard__table-cell">№</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Name</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Period</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Created On</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Status</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Referral code</div>
          </div>
          <div class="exchangeMembershipAppsDashboard__table-body js-customScroll">
            <vue-scroll :ops="ops">
              <div
                v-for="(item, index) of confirmedList"
                :key="index"
                class="exchangeMembershipAppsDashboard__table-row js-acc-item"
              >
                <div class="exchangeMembershipAppsDashboard__table-row-header js-acc-title">
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <div class="exchangeMembershipAppsDashboard__table-index">{{confirmedList.length - index}}</div>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <a
                    @click="openAdditionalDetails(item)"
                    class="exchangeMembershipAppsDashboard__table-name">{{item.firstName + ' ' + item.lastName}}</a>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <div class="exchangeMembershipAppsDashboard__table-phone">{{item.periodName}}</div>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <span>{{getDisplayDateTime(item.createdOn)}}</span>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">{{getPaymentInfoConfirmed(item)}}</div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">{{item.promo ? item.promo.code : ''}}</div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <div class="exchangeMembershipAppsDashboard__content-item js-tabContentItem">
        <div class="exchangeMembershipAppsDashboard__table">
            <Pagination
            :pageCount="declinedListPageCount"
            :rowCount="declinedListCount"
            @pageClick="onDeclinedPageClick"
            />
          <div class="exchangeMembershipAppsDashboard__table-header">
            <div class="exchangeMembershipAppsDashboard__table-cell">№</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Name</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Period</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Created On</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Status</div>
            <div class="exchangeMembershipAppsDashboard__table-cell">Referral code</div>
          </div>
          <div class="exchangeMembershipAppsDashboard__table-body js-customScroll">
            <vue-scroll :ops="ops">
              <div
                v-for="(item, index) of declinedList"
                :key="index"
                class="exchangeMembershipAppsDashboard__table-row js-acc-item"
              >
                <div class="exchangeMembershipAppsDashboard__table-row-header js-acc-title">
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <div class="exchangeMembershipAppsDashboard__table-index">{{declinedList.length - index}}</div>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <a
                    @click="openAdditionalDetails(item)"
                    class="exchangeMembershipAppsDashboard__table-name">{{item.firstName + ' ' + item.lastName}}</a>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <div class="exchangeMembershipAppsDashboard__table-phone">{{item.periodName}}</div>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">
                    <span>{{getDisplayDateTime(item.createdOn)}}</span>
                  </div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">{{getPaymentInfo(item)}}</div>
                  <div class="exchangeMembershipAppsDashboard__table-cell">{{item.promo ? item.promo.code : ''}}</div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
    </div>
    <FlyerDetailsPopup />
    <QuestionPopup
      :name="'QuestionPopupAccept'"
      :title="'The application will be accepted.'"
      :text="'Are you sure?'"
      @remove="acceptApplication"
    />
    <QuestionPopup
      :name="'QuestionPopupDecline'"
      :title="'The application will be decined'"
      :text="'Are you sure?'"
      @remove="declineApplication"
    />
    <InfoPopup/>
  </div>
</template>

<script>
  import { reportsAPI } from '@/api/reports'
  import { Tabs } from '@/js/plugins/tabs'
  import FlyerDetailsPopup from '@/components/common/modals/FlyerDetailsPopup'
  import QuestionPopup from '@/components/common/modals/QuestionPopup'
  import InfoPopup from '@/components/common/modals/InfoPopup.vue';
  import Pagination from '@/components/common/Pagination/Pagination'
  import './ExchangeMembershipApps.styl'
  import moment from 'moment'

  export default {
    name: 'exchangeMembershipApps',
    data: () => ({
      tabs: new Tabs('.js-tabNavItem', '.js-tabContentItem'),
      ops: {
        rail: {
          size: '3px',
        },
        bar: {
          size: '3px',
          background: 'rgba(0,0,0,0.1)',
        },
      },
      tabSelected: 'in-progress',
      currentItem: null,
    }),
    computed: {
      draftsList () {
        return this.$store.state.exchangeMembershipApps.draftsList
      },
      inProgressList () {
        return this.$store.state.exchangeMembershipApps.inProgressList
      },
      confirmedList () {
        return this.$store.state.exchangeMembershipApps.confirmedList
      },
      declinedList () {
        return this.$store.state.exchangeMembershipApps.declinedList
      },
      draftsListPageCount () {
        return this.$store.state.exchangeMembershipApps.draftsListPageCount
      },
      inProgressListPageCount () {
        return this.$store.state.exchangeMembershipApps.inProgressListPageCount
      },
      confirmedListPageCount () {
        return this.$store.state.exchangeMembershipApps.confirmedListPageCount
      },
      declinedListPageCount () {
        return this.$store.state.exchangeMembershipApps.declinedListPageCount
      },
      draftsListCount () {
        return this.$store.state.exchangeMembershipApps.draftsListCount
      },
      inProgressListCount () {
        return this.$store.state.exchangeMembershipApps.inProgressListCount
      },
      confirmedListCount () {
        return this.$store.state.exchangeMembershipApps.confirmedListCount
      },
      declinedListCount () {
        return this.$store.state.exchangeMembershipApps.declinedListCount
      },
    },
    mounted () {
      this.tabs.addActiveForMouted()
    },
    methods: {
      controlShow (event) {
        const item = event.currentTarget.closest('.exchangeMembershipAppsDashboard__table-row').querySelector('.js-acc-hover-content')
        this.$root.animations.slideDown(item)
        item.classList.add('show')
      },
      controlHide (event) {
        const item = event.currentTarget.closest('.exchangeMembershipAppsDashboard__table-row').querySelector('.js-acc-hover-content')
        item.classList.remove('show')
        this.$root.animations.slideUp(item)
      },
      openAdditionalDetails (account) {
        this.$modal.show('FlyerDetailsPopup', {additionalInfo: account})
      },
      moment,
      tabActivate (event) {
        this.tabs.addActiveForClick(event.currentTarget)
        if (event.currentTarget.getAttribute('data-id') === 'in-progress') {
          this.tabSelected = 'in-progress'
        } else if (event.currentTarget.getAttribute('data-id') === 'confirmed') {
          this.tabSelected = 'confirmed'
        } else if (event.currentTarget.getAttribute('data-id') === 'declined') {
          this.tabSelected = 'declined'
        } else {
          this.tabSelected = 'draft'
        }
      },
      async exportToExcel () {
        try {
          const { data } = await reportsAPI.exchangeMembershipApps()
          const downloadLink = document.createElement('a');
          const blob = new Blob(['\ufeff', data]);
          const url = window.URL.createObjectURL(blob);
          downloadLink.href = url;
          downloadLink.download = 'exchangeMembershipApps_report_' + new Date().toLocaleDateString().replaceAll('/', '-') + '.csv';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        } catch (e) {
          console.log(e)
        }
      },
      async onDraftsPageClick (data) {
        await this.$store.dispatch('getDraftsList', data);
      },
      async onInProgressPageClick (data) {
        await this.$store.dispatch('getInProgressList', data);
      },
      async onConfirmedPageClick (data) {
        await this.$store.dispatch('getConfirmedList', data);
      },
      async onDeclinedPageClick (data) {
        await this.$store.dispatch('getDeclinedList', data);
      },
      getDisplayDateTime (dateString) {
        const options = {timeZone: 'America/New_York', hour12: false};
        let date = new Date(dateString);
        date = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        return dateString === null
          ? ''
          : date.toLocaleString('en-US', options);
      },
      getPaymentInfo (item) {
        return item.paid ? 'Paid' : 'Unpaid'
      },
      getPaymentInfoConfirmed (item) {
        let info = item.paid ? 'Paid' : 'Unpaid'
        switch (item.membershipStatus) {
          case 5:
            info += ' - active'
            break
          case 6:
            info += ' - cancelled'
            break
          case 4:
            info += ' - failed'
            break
        }
        return info
      },
      acceptApplicationClick (item) {
        this.currentItem = item;
        this.$modal.show('QuestionPopupAccept');
      },
      declineApplicationClick (item) {
        this.currentItem = item;
        this.$modal.show('QuestionPopupDecline');
      },
      async acceptApplication () {
        if (this.currentItem.possibleFlyer != null) {
          const data = {
            appId: this.currentItem.id,
            accountId: this.currentItem.possibleFlyer.id,
          };
          const res = await this.$store.dispatch('linkAccountAndCreateExchangeMembership', data);
          if (!res.data.isSuccessfull) {
            this.$modal.show('InfoPopup', {
              title: 'Error',
              text: res.data.message,
            });
          } else {
            this.$router.go();
          }
        } else if (this.currentItem.flyer != null) {
          const res = await this.$store.dispatch('createExchangeMembership', this.currentItem.id);
          if (!res.data.isSuccessfull) {
            this.$modal.show('InfoPopup', {
              title: 'Error',
              text: res.data.message,
            });
          } else {
            this.$router.go();
          }
        } else {
          const res = await this.$store.dispatch('createNewAccountAndExchangeMembership', this.currentItem.id);
          if (!res.data.isSuccessfull) {
            this.$modal.show('InfoPopup', {
              title: 'Error',
              text: res.data.message,
            });
          } else {
            this.$router.go();
          }
        }
        this.currentItem = null;
        this.$modal.hide('QuestionPopupAccept')
      },
      async declineApplication () {
        const res = await this.$store.dispatch('declineExchangeMembershipApp', this.currentItem.id);
          if (!res.data.isSuccessfull) {
            this.$modal.show('InfoPopup', {
              title: 'Error',
              text: res.data.message,
            });
          } else {
            this.$router.go();
          }
          this.currentItem = null;
          this.$modal.hide('QuestionPopupDecline')
      },
    },
    components: {
      FlyerDetailsPopup,
      QuestionPopup,
      InfoPopup,
      Pagination,
    },
  }
</script>